/**
 * @param {Object} props
 * @param {string | undefined} [props.className]
 * @param {number | undefined} [props.height]
 * @param {number | undefined} [props.width]
 * @param {string | undefined} [props.color]
 * @param {string | undefined} [props.dataId]
 * @param {boolean} [props.checked]
 * @returns {React.ReactElement} The rendered component
 */
const BookmarkIcon = ({ className, checked, dataId, height, width, color }) => {
  const whiteVariant = className === 'whiteVariant';

  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 30 30"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      data-id={dataId}
    >
      <g id="Symbols">
        <g id="FRE-030_XL" transform="translate(-894.000000, -22.000000)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill={checked ? color : 'none'}
            stroke={whiteVariant ? '#FFFFFF' : color}
            strokeWidth="2"
            strokeMiterlimit="10"
            d="M909,49.9L909,49.9c-0.2,0-0.5-0.1-0.7-0.3l-10.7-11.9h0c-1.3-1.5-2-3.4-2-5.5c0-2.1,0.7-4,2-5.5l0.2-0.2
          c1.3-1.5,3.1-2.4,4.9-2.4c1.9,0,3.7,0.8,5,2.4l1,1.1c0.1,0.2,0.4,0.2,0.5,0l1-1.1c1.3-1.5,3.1-2.4,5-2.4c1.9,0,3.7,0.8,5,2.4
          l0.2,0.2c1.3,1.5,2,3.5,2,5.5c0,2.1-0.7,4.1-2,5.5l-10.7,11.9C909.5,49.8,909.3,49.9,909,49.9"
          />
        </g>
      </g>
    </svg>
  );
};

export default BookmarkIcon;
